<template>
  <ErrorPageBase :statusCode="404">
    申し訳ございませんが、お探しのページは見つかりませんでした。<br />
    移動もしくは削除された可能性があります。
  </ErrorPageBase>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ErrorPageBase from './ErrorPageBase.vue'

export default defineComponent({
  name: 'ErrorNotFound',
  components: {
    ErrorPageBase,
  },
})
</script>
